export const categoryVideos: Record<string, Array<{
  id: string;
  title: string;
  imageUrl: string;
  duration: string;
  views: string;
  date: string;
  isHot?: boolean;
  isNew?: boolean;
}>> = {
  'shishang-chuanda': [
    {
      id: 'feat-1',
      title: '2026夏季时尚穿搭指南｜轻熟风日常搭配分享',
      imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20stylish%20woman%20in%20fashionable%20summer%20outfit%2C%20soft%20natural%20lighting%2C%20minimalist%20warm%20cream%20background%2C%20editorial%20lifestyle%20photography%2C%20clean%20composition%2C%20beauty%20and%20fashion%20aesthetic&width=800&height=450&seq=cat-fashion-01&orientation=landscape',
      duration: '08:24',
      views: '128.6万',
      date: '2026-08-08',
      isHot: true,
    },
    {
      id: 'hot-1',
      title: '一周穿搭不重样｜通勤约会出游全场景搭配',
      imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20woman%20in%20multiple%20fashionable%20outfits%20laid%20out%2C%20minimalist%20white%20bedroom%20background%2C%20warm%20natural%20light%2C%20wardrobe%20planning%20flatlay%20style%2C%20modern%20fashion%20editorial&width=800&height=450&seq=cat-fashion-02&orientation=landscape',
      duration: '10:18',
      views: '256.9万',
      date: '2026-08-09',
      isHot: true,
    },
    {
      id: 'hot-7',
      title: '法式复古穿搭灵感｜经典永不过时的搭配法则',
      imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20French%20vintage%20style%20outfit%2C%20Parisian%20cafe%20background%2C%20warm%20afternoon%20light%2C%20classic%20fashion%20aesthetic%2C%20croissant%20and%20coffee%20on%20table%2C%20romantic%20atmosphere&width=800&height=450&seq=cat-fashion-03&orientation=landscape',
      duration: '11:05',
      views: '198.7万',
      date: '2026-08-06',
      isHot: false,
    },
    {
      id: 'latest-1',
      title: '2026秋季新品开箱｜最值得入手的时尚单品',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20unboxing%20fashion%20items%20on%20clean%20white%20desk%2C%20shopping%20bags%20and%20new%20clothes%2C%20bright%20natural%20light%2C%20minimalist%20bedroom%20background&width=800&height=450&seq=cat-fashion-04&orientation=landscape',
      duration: '13:20',
      views: '45.6万',
      date: '2026-08-09',
      isNew: true,
    },
    {
      id: 'cat-f1',
      title: '小个子女生穿搭技巧｜显高显瘦搭配秘诀',
      imageUrl: 'https://readdy.ai/api/search-image?query=Petite%20stylish%20woman%20in%20well%20fitted%20fashionable%20outfit%2C%20full%20body%20portrait%2C%20minimalist%20white%20studio%20background%2C%20professional%20fashion%20photography%2C%20clean%20lighting&width=800&height=450&seq=cat-fashion-05&orientation=landscape',
      duration: '09:15',
      views: '87.3万',
      date: '2026-08-04',
    },
    {
      id: 'cat-f2',
      title: '职场女性通勤穿搭｜干练优雅不重样',
      imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20woman%20in%20elegant%20office%20outfit%2C%20modern%20office%20background%2C%20natural%20window%20light%2C%20confident%20pose%2C%20corporate%20fashion%20photography%2C%20clean%20composition&width=800&height=450&seq=cat-fashion-06&orientation=landscape',
      duration: '07:48',
      views: '112.5万',
      date: '2026-08-03',
    },
    {
      id: 'cat-f3',
      title: '约会穿搭灵感｜甜美温柔风搭配指南',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20in%20romantic%20date%20outfit%2C%20outdoor%20cafe%20setting%2C%20soft%20afternoon%20light%2C%20sweet%20feminine%20style%2C%20lifestyle%20photography%2C%20warm%20atmosphere&width=800&height=450&seq=cat-fashion-07&orientation=landscape',
      duration: '08:56',
      views: '95.2万',
      date: '2026-08-02',
    },
    {
      id: 'cat-f4',
      title: '配饰搭配小心机｜让整体造型更出彩',
      imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20with%20fashion%20accessories%20jewelry%20and%20bags%2C%20close%20up%20detail%20shot%2C%20minimalist%20marble%20background%2C%20luxury%20fashion%20editorial%2C%20soft%20lighting&width=800&height=450&seq=cat-fashion-08&orientation=landscape',
      duration: '06:32',
      views: '73.8万',
      date: '2026-08-01',
    },
  ],
  'shenghuo-xiezhen': [
    {
      id: 'feat-2',
      title: '海边度假写真｜夏日清新胶片风人像摄影',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20at%20tropical%20beach%20resort%2C%20summer%20vacation%20vibe%2C%20soft%20warm%20sunlight%2C%20film%20photography%20style%2C%20natural%20pose%2C%20clean%20ocean%20background&width=800&height=450&seq=cat-life-01&orientation=landscape',
      duration: '12:15',
      views: '96.3万',
      date: '2026-08-07',
      isHot: true,
    },
    {
      id: 'hot-2',
      title: '樱花季和服写真｜京都春日浪漫之旅',
      imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20beautiful%20kimono%20under%20cherry%20blossom%20trees%2C%20spring%20season%2C%20soft%20pink%20petals%2C%20traditional%20Japanese%20garden%20background%2C%20warm%20sunlight&width=800&height=450&seq=cat-life-02&orientation=landscape',
      duration: '09:42',
      views: '189.4万',
      date: '2026-08-08',
      isHot: true,
    },
    {
      id: 'latest-2',
      title: '傍晚城市漫步｜治愈系生活Vlog',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20walking%20through%20city%20street%20at%20golden%20hour%2C%20warm%20sunset%20light%2C%20urban%20background%2C%20casual%20stylish%20outfit%2C%20lifestyle%20photography&width=800&height=450&seq=cat-life-03&orientation=landscape',
      duration: '07:55',
      views: '32.1万',
      date: '2026-08-09',
      isNew: true,
    },
    {
      id: 'cat-l1',
      title: '咖啡店悠闲午后｜文艺清新日常记录',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20sitting%20in%20cozy%20cafe%2C%20reading%20book%20with%20coffee%2C%20warm%20ambient%20light%2C%20wooden%20interior%2C%20casual%20outfit%2C%20lifestyle%20photography%2C%20relaxed%20vibe&width=800&height=450&seq=cat-life-04&orientation=landscape',
      duration: '08:30',
      views: '65.4万',
      date: '2026-08-05',
    },
    {
      id: 'cat-l2',
      title: '花店一日体验｜被鲜花包围的幸福',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20in%20flower%20shop%20arranging%20fresh%20blooms%2C%20colorful%20flowers%20everywhere%2C%20bright%20natural%20light%2C%20happy%20expression%2C%20lifestyle%20photography%2C%20warm%20atmosphere&width=800&height=450&seq=cat-life-05&orientation=landscape',
      duration: '10:20',
      views: '78.9万',
      date: '2026-08-03',
    },
    {
      id: 'cat-l3',
      title: '居家日常Vlog｜一个人的精致生活',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20in%20cozy%20minimalist%20apartment%2C%20cooking%20in%20kitchen%2C%20warm%20morning%20light%2C%20indoor%20plants%2C%20lifestyle%20photography%2C%20clean%20white%20interior&width=800&height=450&seq=cat-life-06&orientation=landscape',
      duration: '15:42',
      views: '92.1万',
      date: '2026-08-01',
    },
    {
      id: 'cat-l4',
      title: '书店探访记｜寻找城市中的阅读空间',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20browsing%20books%20in%20modern%20bookstore%2C%20tall%20bookshelves%2C%20warm%20soft%20lighting%2C%20intellectual%20aesthetic%2C%20lifestyle%20photography%2C%20quiet%20atmosphere&width=800&height=450&seq=cat-life-07&orientation=landscape',
      duration: '11:18',
      views: '54.3万',
      date: '2026-07-30',
    },
    {
      id: 'cat-l5',
      title: '雨后公园漫步｜清新自然写真拍摄',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20walking%20in%20green%20park%20after%20rain%2C%20fresh%20wet%20leaves%2C%20soft%20overcast%20light%2C%20casual%20outdoor%20outfit%2C%20nature%20photography%2C%20peaceful%20mood&width=800&height=450&seq=cat-life-08&orientation=landscape',
      duration: '09:05',
      views: '61.7万',
      date: '2026-07-29',
    },
  ],
  'caiyi-zhanshi': [
    {
      id: 'feat-3',
      title: '古典舞《惊鸿》完整版｜国风舞蹈才艺展示',
      imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20female%20dancer%20in%20traditional%20Chinese%20dance%20costume%2C%20classical%20dance%20performance%2C%20flowing%20silk%20ribbons%2C%20soft%20dramatic%20lighting%2C%20minimalist%20dark%20background&width=800&height=450&seq=cat-talent-01&orientation=landscape',
      duration: '06:48',
      views: '215.7万',
      date: '2026-08-06',
      isHot: true,
    },
    {
      id: 'hot-3',
      title: '钢琴弹奏《River Flows in You》完整版',
      imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20playing%20grand%20piano%20in%20sunlit%20room%2C%20flowing%20dress%2C%20soft%20window%20light%2C%20classical%20music%20atmosphere%2C%20minimalist%20interior&width=800&height=450&seq=cat-talent-02&orientation=landscape',
      duration: '04:56',
      views: '312.1万',
      date: '2026-08-08',
      isHot: true,
    },
    {
      id: 'hot-8',
      title: '吉他弹唱《晴天》｜温暖治愈的午后时光',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20playing%20acoustic%20guitar%20by%20sunny%20window%2C%20cozy%20room%20with%20plants%2C%20warm%20afternoon%20light%2C%20casual%20outfit%2C%20music%20lifestyle%20aesthetic&width=800&height=450&seq=cat-talent-03&orientation=landscape',
      duration: '05:30',
      views: '278.4万',
      date: '2026-08-05',
      isHot: false,
    },
    {
      id: 'latest-3',
      title: '街舞编舞作品《Fire》｜力量与美感并存',
      imageUrl: 'https://readdy.ai/api/search-image?query=Energetic%20woman%20dancing%20street%20dance%20in%20urban%20studio%2C%20dynamic%20pose%2C%20industrial%20loft%20background%2C%20dramatic%20lighting%2C%20hip%20hop%20style&width=800&height=450&seq=cat-talent-04&orientation=landscape',
      duration: '04:12',
      views: '67.8万',
      date: '2026-08-09',
      isNew: true,
    },
    {
      id: 'cat-t1',
      title: '小提琴独奏《梁祝》｜经典旋律感动人心',
      imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20playing%20violin%20in%20concert%20hall%2C%20dramatic%20stage%20lighting%2C%20classical%20music%20performance%2C%20artistic%20composition%2C%20emotional%20expression&width=800&height=450&seq=cat-talent-05&orientation=landscape',
      duration: '08:15',
      views: '156.3万',
      date: '2026-08-04',
    },
    {
      id: 'cat-t2',
      title: '水彩画教程｜从零开始学画花卉',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20painting%20watercolor%20flowers%20at%20desk%2C%20art%20supplies%20around%2C%20soft%20natural%20light%2C%20creative%20studio%20atmosphere%2C%20artistic%20lifestyle&width=800&height=450&seq=cat-talent-06&orientation=landscape',
      duration: '20:30',
      views: '89.4万',
      date: '2026-08-03',
    },
    {
      id: 'cat-t3',
      title: '现代舞即兴表演｜情感与肢体的对话',
      imageUrl: 'https://readdy.ai/api/search-image?query=Graceful%20female%20contemporary%20dancer%20in%20white%20studio%2C%20fluid%20movement%2C%20dramatic%20shadow%20and%20light%2C%20artistic%20dance%20photography%2C%20expressive%20pose&width=800&height=450&seq=cat-talent-07&orientation=landscape',
      duration: '05:22',
      views: '134.6万',
      date: '2026-08-02',
    },
    {
      id: 'cat-t4',
      title: '翻唱《起风了》｜温柔女声治愈翻唱',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20singing%20with%20microphone%20in%20recording%20studio%2C%20warm%20ambient%20lighting%2C%20professional%20music%20setup%2C%20emotional%20performance&width=800&height=450&seq=cat-talent-08&orientation=landscape',
      duration: '04:38',
      views: '201.5万',
      date: '2026-08-01',
    },
  ],
  'meirong-meizhuang': [
    {
      id: 'feat-4',
      title: '日系清透妆容教程｜新手也能轻松掌握',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20applying%20natural%20makeup%2C%20Japanese%20style%20clean%20look%2C%20soft%20daylight%20by%20window%2C%20minimalist%20vanity%20setup%2C%20warm%20neutral%20background&width=800&height=450&seq=cat-beauty-01&orientation=landscape',
      duration: '15:32',
      views: '89.2万',
      date: '2026-08-05',
      isHot: true,
    },
    {
      id: 'hot-4',
      title: '秋冬护肤全攻略｜干燥季节的保湿秘诀',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20with%20skincare%20products%20on%20marble%20vanity%2C%20fresh%20clean%20skin%2C%20soft%20natural%20light%2C%20minimalist%20bathroom%20setting%2C%20wellness%20beauty%20aesthetic&width=800&height=450&seq=cat-beauty-02&orientation=landscape',
      duration: '14:23',
      views: '167.3万',
      date: '2026-08-07',
      isHot: true,
    },
    {
      id: 'latest-4',
      title: '眼部遮瑕大法｜告别黑眼圈泪沟困扰',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20demonstrating%20concealer%20makeup%20technique%20close%20up%2C%20flawless%20skin%2C%20beauty%20mirror%20reflection%2C%20bright%20vanity%20lighting&width=800&height=450&seq=cat-beauty-03&orientation=landscape',
      duration: '09:38',
      views: '28.9万',
      date: '2026-08-09',
      isNew: true,
    },
    {
      id: 'cat-b1',
      title: '夏日持久底妆教程｜控油不脱妆的秘密',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20applying%20foundation%20with%20sponge%2C%20flawless%20makeup%20application%2C%20bright%20studio%20lighting%2C%20beauty%20tutorial%20setup%2C%20professional%20cosmetics&width=800&height=450&seq=cat-beauty-04&orientation=landscape',
      duration: '12:08',
      views: '145.6万',
      date: '2026-08-04',
    },
    {
      id: 'cat-b2',
      title: '韩国美妆博主的化妆包大公开',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20with%20luxury%20cosmetics%20collection%20laid%20out%2C%20vanity%20table%20organization%2C%20soft%20natural%20light%2C%20beauty%20influencer%20aesthetic&width=800&height=450&seq=cat-beauty-05&orientation=landscape',
      duration: '16:45',
      views: '98.7万',
      date: '2026-08-03',
    },
    {
      id: 'cat-b3',
      title: '发型教程｜日常编发造型轻松get',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20styling%20hair%20braid%20tutorial%2C%20mirror%20reflection%2C%20soft%20bedroom%20lighting%2C%20elegant%20hairstyle%2C%20beauty%20tutorial%20photography&width=800&height=450&seq=cat-beauty-06&orientation=landscape',
      duration: '08:50',
      views: '112.3万',
      date: '2026-08-01',
    },
    {
      id: 'cat-b4',
      title: '唇妆试色合集｜2026最火口红色号',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20showing%20lipstick%20swatches%2C%20various%20red%20and%20pink%20shades%2C%20close%20up%20beauty%20shot%2C%20soft%20natural%20lighting%2C%20professional%20makeup&width=800&height=450&seq=cat-beauty-07&orientation=landscape',
      duration: '10:15',
      views: '178.9万',
      date: '2026-07-31',
    },
    {
      id: 'cat-b5',
      title: '睡前护肤流程｜打造水嫩好肌肤',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20doing%20night%20skincare%20routine%2C%20serums%20and%20creams%2C%20warm%20bedroom%20lighting%2C%20relaxing%20atmosphere%2C%20wellness%20aesthetic&width=800&height=450&seq=cat-beauty-08&orientation=landscape',
      duration: '13:28',
      views: '134.2万',
      date: '2026-07-30',
    },
  ],
  'jianshen-yundong': [
    {
      id: 'feat-5',
      title: '居家瑜伽跟练｜30分钟全身燃脂塑形',
      imageUrl: 'https://readdy.ai/api/search-image?query=Fit%20woman%20doing%20yoga%20pose%20in%20bright%20minimalist%20home%20studio%2C%20morning%20sunlight%20streaming%20through%20window%2C%20light%20wooden%20floor%2C%20white%20walls%2C%20wellness%20lifestyle&width=800&height=450&seq=cat-fitness-01&orientation=landscape',
      duration: '32:10',
      views: '176.5万',
      date: '2026-08-05',
      isHot: true,
    },
    {
      id: 'hot-5',
      title: '普拉提核心训练｜改善体态塑造小蛮腰',
      imageUrl: 'https://readdy.ai/api/search-image?query=Fit%20woman%20doing%20pilates%20on%20reformer%20machine%2C%20bright%20airy%20studio%20with%20large%20windows%2C%20minimalist%20white%20interior%2C%20morning%20light&width=800&height=450&seq=cat-fitness-02&orientation=landscape',
      duration: '25:08',
      views: '203.7万',
      date: '2026-08-07',
      isHot: false,
    },
    {
      id: 'cat-fit1',
      title: '晨间拉伸10分钟｜唤醒身体开始新一天',
      imageUrl: 'https://readdy.ai/api/search-image?query=Fit%20woman%20stretching%20in%20sunny%20living%20room%2C%20morning%20routine%2C%20comfortable%20activewear%2C%20warm%20natural%20light%2C%20wellness%20lifestyle%20photography&width=800&height=450&seq=cat-fitness-03&orientation=landscape',
      duration: '10:05',
      views: '89.6万',
      date: '2026-08-06',
    },
    {
      id: 'cat-fit2',
      title: '跳绳燃脂挑战｜2000次打卡训练',
      imageUrl: 'https://readdy.ai/api/search-image?query=Fit%20woman%20jumping%20rope%20outdoors%20in%20park%2C%20dynamic%20action%20shot%2C%20sunny%20day%2C%20sporty%20activewear%2C%20fitness%20lifestyle%20photography&width=800&height=450&seq=cat-fitness-04&orientation=landscape',
      duration: '18:30',
      views: '123.4万',
      date: '2026-08-04',
    },
    {
      id: 'cat-fit3',
      title: '蜜桃臀训练计划｜居家无器械练臀',
      imageUrl: 'https://readdy.ai/api/search-image?query=Fit%20woman%20doing%20glute%20exercises%20at%20home%2C%20yoga%20mat%20on%20floor%2C%20bright%20minimalist%20room%2C%20fitness%20lifestyle%2C%20clean%20composition&width=800&height=450&seq=cat-fitness-05&orientation=landscape',
      duration: '22:15',
      views: '167.8万',
      date: '2026-08-03',
    },
    {
      id: 'cat-fit4',
      title: '有氧搏击操｜释放压力暴汗燃脂',
      imageUrl: 'https://readdy.ai/api/search-image?query=Energetic%20woman%20doing%20kickboxing%20workout%2C%20boxing%20gloves%2C%20gym%20studio%20background%2C%20dynamic%20lighting%2C%20fitness%20photography%2C%20powerful%20pose&width=800&height=450&seq=cat-fitness-06&orientation=landscape',
      duration: '28:40',
      views: '145.2万',
      date: '2026-08-01',
    },
    {
      id: 'cat-fit5',
      title: '天鹅臂训练｜打造优雅肩颈线条',
      imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20doing%20arm%20toning%20exercises%2C%20graceful%20movement%2C%20bright%20airy%20room%2C%20light%20color%20activewear%2C%20ballet%20inspired%20workout&width=800&height=450&seq=cat-fitness-07&orientation=landscape',
      duration: '15:20',
      views: '92.7万',
      date: '2026-07-31',
    },
    {
      id: 'cat-fit6',
      title: '跑者日常｜5公里晨跑训练Vlog',
      imageUrl: 'https://readdy.ai/api/search-image?query=Fit%20woman%20running%20in%20scenic%20park%20at%20sunrise%2C%20morning%20light%2C%20active%20lifestyle%2C%20nature%20background%2C%20running%20photography%2C%20energetic%20vibe&width=800&height=450&seq=cat-fitness-08&orientation=landscape',
      duration: '20:08',
      views: '78.3万',
      date: '2026-07-30',
    },
  ],
  'luxing-meishi': [
    {
      id: 'feat-6',
      title: '成都美食探店｜隐藏在巷子里的地道川味',
      imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20enjoying%20food%20at%20traditional%20Chinese%20restaurant%2C%20warm%20ambient%20lighting%2C%20wooden%20interior%2C%20steaming%20dishes%20on%20table%2C%20cozy%20atmosphere&width=800&height=450&seq=cat-travel-01&orientation=landscape',
      duration: '18:45',
      views: '143.8万',
      date: '2026-08-04',
      isHot: true,
    },
    {
      id: 'hot-6',
      title: '东京涩谷逛街Vlog｜潮流圣地购物分享',
      imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20woman%20walking%20through%20Tokyo%20shopping%20district%2C%20colorful%20neon%20signs%20background%2C%20urban%20fashion%20vibe%2C%20bustling%20city%20street%2C%20modern%20lifestyle&width=800&height=450&seq=cat-travel-02&orientation=landscape',
      duration: '21:36',
      views: '134.2万',
      date: '2026-08-06',
      isHot: false,
    },
    {
      id: 'cat-tr1',
      title: '大理洱海环湖骑行｜风花雪月的浪漫',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20cycling%20along%20scenic%20lake%20in%20Dali%2C%20blue%20sky%20and%20mountains%20background%2C%20travel%20adventure%2C%20bright%20sunlight%2C%20nature%20photography&width=800&height=450&seq=cat-travel-03&orientation=landscape',
      duration: '16:20',
      views: '108.6万',
      date: '2026-08-05',
    },
    {
      id: 'cat-tr2',
      title: '上海弄堂里的隐藏咖啡馆探店',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20at%20charming%20hidden%20cafe%20in%20Shanghai%20alleyway%2C%20vintage%20decor%2C%20warm%20afternoon%20light%2C%20coffee%20and%20pastries%2C%20lifestyle%20photography&width=800&height=450&seq=cat-travel-04&orientation=landscape',
      duration: '12:35',
      views: '76.9万',
      date: '2026-08-03',
    },
    {
      id: 'cat-tr3',
      title: '曼谷夜市美食之旅｜街头小吃吃不停',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20at%20Bangkok%20night%20market%20with%20street%20food%2C%20colorful%20lights%2C%20bustling%20atmosphere%2C%20exotic%20dishes%2C%20travel%20food%20photography&width=800&height=450&seq=cat-travel-05&orientation=landscape',
      duration: '19:50',
      views: '156.3万',
      date: '2026-08-02',
    },
    {
      id: 'cat-tr4',
      title: '冰岛极光之旅｜追逐北极光的梦幻夜晚',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20watching%20northern%20lights%20in%20Iceland%2C%20aurora%20borealis%20sky%2C%20winter%20landscape%2C%20magical%20atmosphere%2C%20travel%20adventure%20photography&width=800&height=450&seq=cat-travel-06&orientation=landscape',
      duration: '25:15',
      views: '189.7万',
      date: '2026-07-31',
    },
    {
      id: 'cat-tr5',
      title: '广州早茶文化｜一盅两件的悠闲时光',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20enjoying%20dim%20sum%20at%20traditional%20Guangzhou%20tea%20house%2C%20steaming%20bamboo%20baskets%2C%20elegant%20Chinese%20decor%2C%20food%20photography&width=800&height=450&seq=cat-travel-07&orientation=landscape',
      duration: '14:08',
      views: '134.5万',
      date: '2026-07-30',
    },
    {
      id: 'cat-tr6',
      title: '巴厘岛度假Vlog｜热带天堂的完美假期',
      imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20at%20luxury%20Bali%20resort%20with%20infinity%20pool%2C%20tropical%20paradise%2C%20palm%20trees%2C%20ocean%20view%2C%20vacation%20lifestyle%20photography&width=800&height=450&seq=cat-travel-08&orientation=landscape',
      duration: '22:30',
      views: '201.2万',
      date: '2026-07-29',
    },
  ],
};